const hasValue = (value) =>
  value !== undefined && value !== null && value !== '';

const normalizeThreadId = (threadId) =>
  hasValue(threadId) ? String(threadId) : null;

const areSameThread = (leftThreadId, rightThreadId) => {
  const left = normalizeThreadId(leftThreadId);
  const right = normalizeThreadId(rightThreadId);

  return Boolean(left && right && left === right);
};

const shouldStartThreadMessageFetch = ({
  fetchingThreadId,
  requestedThreadId,
} = {}) => !areSameThread(fetchingThreadId, requestedThreadId);

const shouldCommitThreadMessagesToCurrentView = ({
  currentThreadId,
  responseThreadId,
} = {}) => areSameThread(currentThreadId, responseThreadId);

export {
  areSameThread,
  shouldCommitThreadMessagesToCurrentView,
  shouldStartThreadMessageFetch,
};
